import { Form, Input, Col, Row, Card, Radio, Button, Space } from 'antd'
import { ReloadOutlined, SearchOutlined } from '@ant-design/icons'
import StoreSelectBase from '../../../components/BaseInfoSelects/StoreSelectBase'
import TimeDurationFormItem from '../../../components/TimeDurationFormItem'
import AuthComponent from '../../../components/AuthComponent'
import { checkBillStatusMap } from '../config'
const basicDurationKeys = ['queryAfterCheckTime', 'queryBeforeCheckTime']
const initialValues = {
  checkStatus: ''
}
const shopKey = 'storeCode'
export default function CheckListBasicForm({
  getList,
  showAdd = () => {},
  children = '',
  checkNo = ''
}) {
  const [form] = Form.useForm()
  const getDefaultStoreCodeAndRequst = res => {
    console.log(res)
    form.setFieldsValue({ storeCode: res.storeCode })
    baseGetListByFormData()
  }
  form.setFieldsValue({checkNo: checkNo})
  const baseGetListByFormData = () => {
    if (form.getFieldValue('storeCode')) {
      let formData = form.getFieldsValue()
      delete formData.duration
      getList({ formData: formData })
    }
  }
  return (
    <Card>
      <Form
        wrapperCol={{ style: { marginBottom: 20 } }}
        layout='inline'
        labelCol={{ style: { width: 90, textAlign: 'right' } }}
        form={form}
        initialValues={initialValues}>
        <Form.Item name={shopKey} label='所属门店' required>
          <StoreSelectBase
            keyVal={shopKey}
            style={{ width: 180 }}
            OnOptionsLoad={getDefaultStoreCodeAndRequst}
          />
        </Form.Item>
        <Form.Item name='checkNo' label='盘点单据'>
          <Input placeholder='请输入' style={{ width: 180 }} />
        </Form.Item>
        <TimeDurationFormItem
          keys={basicDurationKeys}
          label='单据时间'
          form={form}
        />
        <Form.Item
          name='checkStatus'
          label='单据状态'
          style={{ textAlign: 'left' }}>
          <Radio.Group>
            <Radio value={''}>全部</Radio>
            {Object.keys(checkBillStatusMap).map(item => (
              <Radio key={item} value={item}>
                {checkBillStatusMap[item]}
              </Radio>
            ))}
          </Radio.Group>
        </Form.Item>
      </Form>
      <Space>
        <AuthComponent authKey='/inventory/check-sheet/list'>
          <Button
            type='primary'
            ghost
            onClick={baseGetListByFormData}
            icon={<SearchOutlined />}>
            查询
          </Button>
        </AuthComponent>
        <Button
          type='primary'
          ghost
          icon={<ReloadOutlined />}
          onClick={() => form.resetFields()}>
          重置
        </Button>
        {children}
      </Space>
    </Card>
  )
}
